import React from 'react';
import { Drawer, DrawerTitle } from '../../../Components/Drawer';
import { ShortcutsListView } from './components/ShortcutsListView';
import { marginSize, paddingSize } from '../../../Utilities/utils/Theming';
import { TShortcutListDrawer } from './types'

function ShortcutsListDrawer(
    {
        id = 'shortcuts-list',
        title,
        defaultGroupTitle,
        isOpen,
        onCloseShorcuts,
        viewMode,
        showBackdrop,
        zIndex = 1,
        offset = '0px',
        enableSearch,
        enableShortcutsActions,
    }: TShortcutListDrawer) {

    return <Drawer
        showBackdrop={showBackdrop}
        anchor="right"
        isOpen={isOpen}
        onClose={onCloseShorcuts}
        zIndex={zIndex}
        offset={offset}
        overrides={{
            DrawerBody: {
                style: () => {
                    return {
                        ...paddingSize('var(--epods--space-inset-s)', '0px', '0px', 'var(--epods--space-inset-s)'),
                        ...marginSize('0px', 'var(--epods--space-inset-s)', '0px', 'var(--epods--space-inset-s)'),
                        overflowY: 'hidden',
                    };
                },
            },
        }}
    >
        {title && <DrawerTitle>{title}</DrawerTitle>}
        <ShortcutsListView
            id={id}
            defaultGroupTitle={defaultGroupTitle}
            viewMode={viewMode} offset={offset}
            enableSearch={enableSearch}
            enableShortcutsActions={enableShortcutsActions} />
    </Drawer >
}

export default ShortcutsListDrawer;